import { persistedFetcher } from '@amazeelabs/silverback-graphql-persisted';

import queryMap from '../../generated/persisted-queries-map.json';

export function fetcher<TData, TVariables>(
  query: string,
  variables?: TVariables,
): () => Promise<TData> {
  return persistedFetcher(
    process.env.GATSBY_GRAPHQL_ENDPOINT!,
    queryMap,
    query,
    variables,
    // Force POST requests for currentUser queries if we believe that the user
    // is logged in.
    query.includes('currentUser') &&
      typeof window !== 'undefined' &&
      window.document.cookie.includes('drupal_user'),
  );
}
